import React, { useState } from 'react';
import styled from 'styled-components';

const PlaceSettingModal = ({ setting, onClose, onConfirm }) => {
	const [defaultCollapse, setDefaultCollapse] = useState(setting.default_collapse);

	return (
		<ModalContainer>
			<Content>
				<ModalTopContainer>
					<ModalTitle>위치 설정</ModalTitle>
					<CloseButton onClick={onClose}>x</CloseButton>
				</ModalTopContainer>
				<SettingContainer>
					<SettingTitle>위치 목록 기본 표시 상태</SettingTitle>
					<SettingItem>
						<SettingItemCheckbox
							type="radio"
							id="default_collapse_true"
							checked={defaultCollapse}
							onChange={() => setDefaultCollapse(true)}
						/>
						<SettingItemLabel htmlFor="default_collapse_true">접기</SettingItemLabel>
					</SettingItem>
					<SettingItem>
						<SettingItemCheckbox
							type="radio"
							id="default_collapse_false"
							checked={!defaultCollapse}
							onChange={() => setDefaultCollapse(false)}
						/>
						<SettingItemLabel htmlFor="default_collapse_false">펼치기</SettingItemLabel>
					</SettingItem>
				</SettingContainer>
				<Footer>
					<CancelButton onClick={onClose}>취소</CancelButton>
					<OkButton onClick={() => onConfirm({ default_collapse: defaultCollapse })}>확인</OkButton>
				</Footer>
			</Content>
		</ModalContainer>
	);
};

const ModalContainer = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.7);
	z-index: 99999;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const Content = styled.div`
	position: relative;
	width: 720px;
	max-height: 80%;
	overflow-y: scroll;

	background-color: white;
	border: 1px solid #777777;
	box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.25);
`;

const ModalTopContainer = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 20px 30px;
	border-bottom: 1px solid #cccccc;
`;

const ModalTitle = styled.span`
	font-family: 'Pretendard';
	font-style: normal;
	font-weight: 600;
	font-size: 22px;
	line-height: 26px;
	color: #000000;
`;

const CloseButton = styled.div`
	width: 30px;
	height: 30px;
	display: flex;
	align-items: flex-end;
	justify-content: center;

	cursor: pointer;

	color: #000000;
	font-family: 'Noto Sans';
	font-size: 24px;
	font-weight: 500;
	font-style: normal;
	letter-spacing: -1.2px;
	line-height: 30px;
	padding-top: 0px;
`;

const SettingContainer = styled.div`
	margin-top: 20px;
	padding: 0px 30px;

	display: flex;
	align-items: center;
	gap: 20px;
`;

const SettingTitle = styled.span`
	font-family: 'Pretendard';
	font-style: normal;
	font-weight: 600;
	font-size: 16px;
	line-height: 19px;
`;

const SettingItem = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const SettingItemCheckbox = styled.input`
	width: 15px;
	height: 15px;
	border: 1px solid #c5c5c5;
	cursor: pointer;
`;

const SettingItemLabel = styled.label`
	font-family: 'Pretendard';
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 19px;
	cursor: pointer;
`;

const Footer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 30px 0;
`;

const CancelButton = styled.div`
	width: 125px;
	height: 50px;
	border: 1px solid #22499d;
	border-radius: 5px;
	background-color: #ffffff;

	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;

	font-family: 'Pretendard';
	font-style: normal;
	font-weight: 700;
	font-size: 16px;
	line-height: 19px;
	display: flex;
	align-items: center;
	color: #22499d;

	&:hover {
		background-color: #0c438d;
		color: #ffffff;
	}
`;

const OkButton = styled.div`
	width: 125px;
	height: 50px;
	margin-left: 10px;

	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;

	background-color: #22499d;
	border-radius: 5px;

	font-family: 'Pretendard';
	font-style: normal;
	font-weight: 700;
	font-size: 16px;
	line-height: 19px;
	display: flex;
	align-items: center;
	color: #ffffff;

	&:hover {
		background-color: #0c438d;
	}
`;

export default PlaceSettingModal;
